import script from "./CguCgvPros.vue?vue&type=script&setup=true&lang=js"
export * from "./CguCgvPros.vue?vue&type=script&setup=true&lang=js"

import "./CguCgvPros.vue?vue&type=style&index=0&id=7dfdb892&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7dfdb892"]])

export default __exports__